import { isEmpty, isEqual, isObject, omit, transform } from "lodash-es"
import { deepObserve } from "mobx-utils"
import { IDisposer } from "mobx-utils/lib/utils"

import { ITrackingPageOptions } from "@/models/ITrackingPageOptions"
import { initModulesStore } from "@/pages/TrackingPage/EstimatedDeliveryTime/listener"
import { getDiffOptions } from "@/pages/TrackingPage/TrackingPage"
import stores from "@/stores"
import { createUndoHistory } from "@/utils/createUndoHistory"

export let disposer: IDisposer | null = null
let defaultOptions: ITrackingPageOptions

/**
 * 跟踪页编辑的撤销 / 重做历史
 * productCollection 为接口单独拉取的数据，不属于编辑内容
 */
export const trackingPageHistory = createUndoHistory<Partial<ITrackingPageOptions>>({
  getSnapshot: () => omit(stores.trackingPageStore.options, "productCollection"),
  applySnapshot: (snapshot) => {
    const { trackingPageStore, eddModulesStore, userInfoSore } = stores

    trackingPageStore.setBaseOptions(snapshot)

    // 与「放弃修改」保持一致：EDD 子模块未单独编辑时跟随同步
    if (!eddModulesStore.saveBtnActive) {
      initModulesStore()
    }
    userInfoSore.setDataSingle("showPPBranding", !trackingPageStore.brandingConfig?.isRemovedBranding)
  },
})

export default {

  /**
   * 销毁监听器
   */
  destroyListener(focus: boolean = false) {
    // window.onbeforeunload = null
    disposer && disposer()
    disposer = null
    focus && stores.trackingPageStore.setLoadedDataTime(0)
    stores.commonStore.setContextualSaveBar("show", false)
    return true
  },


  /**
   * Deep diff between two object, using lodash
   * @param  {Object} object Object compared
   * @param  {Object} base   Object to compare with
   * @return {Object}        Return a new object who represent the diff
   */
  difference(object: object, base: object) {
    function changes(object: object, base: object) {
      return transform(object, function (result: any, value, key) {
        if (!isEqual(value, base[key])) {
          result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value
        }
      })
    }

    return changes(object, base)
  },


  /**
   * 获取初始值配置
   */
  getInitOptions(): ITrackingPageOptions {
    return defaultOptions || {}
  },


  /**
   * 注册监听器
   */
  registerListener() {
    console.info("TrackingPageUtils: registerListener")
    // 先释放上一次的监听，避免重复注册导致监听器堆积
    disposer && disposer()
    trackingPageHistory.reset()
    disposer = deepObserve(stores.trackingPageStore, (change, path) => {
      trackingPageHistory.record()
      if (change.type === "update" && change.observableKind === "object") {
        stores.commonStore.setContextualSaveBar("show", !isEmpty(getDiffOptions()))
        // !window.onbeforeunload && (window.onbeforeunload = () => "Unsaved changes!")
      }
    })
    return true
  },


  /**
   * 设置初始值
   * @param options
   */
  setInitOptions(options: ITrackingPageOptions) {
    defaultOptions = options
    return true
  },
}
